import { render } from "./PropertyControlError.vue?vue&type=template&id=639b95fd&scoped=true"
import script from "./PropertyControlError.vue?vue&type=script&lang=js"
export * from "./PropertyControlError.vue?vue&type=script&lang=js"

import "./PropertyControlError.vue?vue&type=style&index=0&id=639b95fd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639b95fd"]])

export default __exports__